import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import MobileStepper from '@mui/material/MobileStepper';
import utils from 'helpers/utils';

const StyledMobileStepper = styled(MobileStepper)
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--mobile-stepper-dot-background-color': props.theme.property('palette.divider'),
      '--mobile-stepper-dot-active-background-color': props.theme.property(`palette.${props.$color}.main`)
    };

    return utils.styleProps(attr, vars);
  })` 
  .MuiMobileStepper-dot {
    background-color: ${props => props.$css.$var('--mobile-stepper-dot-background-color')};
    
    &.MuiMobileStepper-dotActive {
      background-color: ${props => props.$css.$var('--mobile-stepper-dot-active-background-color')};
    }
  }
  
  ${ComponentStyles}
`;

StyledMobileStepper.propTypes = {
  theme: PropTypes.object
};

export default StyledMobileStepper;
